module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAAAXNSR0IArs4c6QAAAOdJREFUWEftmM0NgzAMRskmLMBcnJmEc+diATYJ6iESCDf6/NOmQR9nBz8esWU5DZ08qRPOoU/QnPMLNZxSmtHYc5w1x8Wo9SUaYGsOEdRqSwNciy0fc+YgqMcujXrsSWddRsdtzdFA7/ft03Lr5QT1mH620ZqZX95RiQMeSggqVD2NRld9qNF9Wkx847ZezkntiaAatTRabLGPso9qKgeI/Xp7AhigEBOoNFm3KCZO+NA//hD07Am/dkc91rRnXXdUm8wTT1CPvfBNSTRMyNoRgbLuUEMXuX8PigC2ioEXEK0AS95uQA83XhQ6tu/fkAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/share/addFriend/qr.png
// module id = /NKJ
// module chunks = 0